var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBrandOffpeak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6uufp66jda",
    d: "M0 0h73v57.791H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.604)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xrxh7r0fhb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6uufp66jda"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m43.301 31.833-5.52-4.73-5.523 4.732-4.898-4.22 10.59-18.13 9.736 18.603-4.385 3.745zm29.41 22.588.009-.005-9.03-16.31-3.135 4.664L38.173 0 20.248 30.68l-4.83-4.788L.216 54.515l.006.003a2.258 2.258 0 0 0-.222.967 2.28 2.28 0 0 0 4.362.93l.003.001 12.204-22.93 4.662 4.62 3.788-6.487 7.24 6.225 5.521-4.733 5.524 4.734 6.553-5.607 10.205 19.499 3.271-4.87 5.326 9.628.008-.003a2.274 2.274 0 0 0 2.052 1.3c1.259 0 2.28-1.021 2.28-2.282 0-.397-.11-.764-.288-1.09z",
    fill: "#E10A0A",
    mask: "url(#xrxh7r0fhb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.688 7.604h1.562a1.5 1.5 0 0 1 1.5 1.5v31.959h-3.063a1.5 1.5 0 0 1-1.5-1.5V9.104a1.5 1.5 0 0 1 1.5-1.5z",
    fill: "#E10A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.224 10.052 18.294 6.789c2.04.757 1.953 3.765-.127 4.395l-18.294 5.545-1.262-4.437 11.704-3.55-11.83-4.39 1.515-4.352z",
    fill: "#E10A0A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrandOffpeak);
export default __webpack_public_path__ + "static/media/icon-brand-offpeak.a76c02ceaa67f35ba789b64ee460515e.svg";
export { ForwardRef as ReactComponent };